import { render, staticRenderFns } from "./RiskPie.vue?vue&type=template&id=5bd12f68&scoped=true&"
import script from "./RiskPie.vue?vue&type=script&lang=js&"
export * from "./RiskPie.vue?vue&type=script&lang=js&"
import style0 from "./RiskPie.vue?vue&type=style&index=0&id=5bd12f68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd12f68",
  null
  
)

export default component.exports